import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { authUser } from '../../../interfaces';
import { Pillar, Strategy } from '../../../interfaces/models/strategy.model';
import { AuthService } from '../../../services/auth.service';
import { DirectionService } from '../../../services/direction.service';
import { SocketService } from '../../../services/socket.service';
import { StrategyService } from '../../../services/strategy.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-strategy-executor-home',
  standalone: true,
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    DropdownModule,
    FormsModule
  ],
  templateUrl: './strategy-executor-home.component.html',
  styleUrl: './strategy-executor-home.component.scss'
})
export class StrategyExecutorHomeComponent implements OnDestroy, OnInit, AfterViewInit {
  strategyOptions = [] as { name: string, strategyId: number }[];
  selectedStrategyId = 0;
  selectedStrategy = {} as Strategy;
  alignmentStrategy = {} as any;
  selectedPillar = { id: 0 } as any;
  dir!: "rtl" | "ltr";
  pillars = [] as any;
  user!: authUser;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private strategyService: StrategyService,
    private directionService: DirectionService,
    private socketService: SocketService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.animateCounters();
    }, 300);
  }
  
  ngOnInit(): void {
    this.authService.authBufferSub$.pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) => {
        this.user = user as authUser;
      });

    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ viewBag }) => {
        this.strategyOptions = viewBag.stratgies.map((x: any) => ({ name: x.name, strategyId: x.id }));
        this.strategyService.setStrategyIdfn(this.selectedStrategyId);
        this.alignmentStrategy = viewBag.strategyAlignment['data']['strategy'];
        this.pillars = [...this.alignmentStrategy.pillars];
        this.selectedStrategyId = this.alignmentStrategy.id;
        this.selectedStrategy = this.alignmentStrategy as Strategy;
        
        // Set first pillar as default
        if (this.alignmentStrategy?.pillars?.length > 0) {
          this.selectedPillar = this.alignmentStrategy.pillars[0];
        }
      });

    this.directionService.direction$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(dir => {
        this.dir = dir;
      });
  }

  onPillarChange() {
    console.log('Selected pillar:', this.selectedPillar);
  }

  getTotalPillarsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.length;
  }

  getTotalGoalsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.length || 0);
    }, 0);
  }

  getTotalIndicatorsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.reduce((sum: number, goal: any) => sum + (goal.no_indicators || 0), 0) || 0);
    }, 0);
  }

  getTotalProjectsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.reduce((sum: number, goal: any) => sum + (goal.no_projects || 0), 0) || 0);
    }, 0);
  }

  animateCounters() {
    const counters = document.querySelectorAll('.count-animation');
    counters.forEach((counter: any) => {
      counter.textContent = '0';
      
      const target = +counter.getAttribute('data-target') || 0;
      const duration = 1500;
      const step = Math.max(1, Math.ceil(target / 60));
      const interval = duration / 60;
      
      let current = 0;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        counter.textContent = current.toString();
      }, interval);
    });
  }

}
